var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppleLogosvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6734 7.22161C10.7974 7.22161 9.44138 6.22561 8.01338 6.26161C6.12938 6.28561 4.40138 7.35361 3.42938 9.04561C1.47338 12.4416 2.92538 17.4576 4.83338 20.2176C5.76938 21.5616 6.87338 23.0736 8.33738 23.0256C9.74138 22.9656 10.2694 22.1136 11.9734 22.1136C13.6654 22.1136 14.1454 23.0256 15.6334 22.9896C17.1454 22.9656 18.1054 21.6216 19.0294 20.2656C20.0974 18.7056 20.5414 17.1936 20.5654 17.1096C20.5294 17.0976 17.6254 15.9816 17.5894 12.6216C17.5654 9.81361 19.8814 8.46961 19.9894 8.40961C18.6694 6.47761 16.6414 6.26161 15.9334 6.21361C14.0854 6.06961 12.5374 7.22161 11.6734 7.22161ZM14.7934 4.38961C15.5734 3.45361 16.0894 2.14561 15.9454 0.849609C14.8294 0.897609 13.4854 1.59361 12.6814 2.52961C11.9614 3.35761 11.3374 4.68961 11.5054 5.96161C12.7414 6.05761 14.0134 5.32561 14.7934 4.38961Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleLogosvg);
export default __webpack_public_path__ + "static/media/apple-logo.svg.8692b4f527ab911c50ceb9ef2826603f.svg";
export { ForwardRef as ReactComponent };